import { BUSINESS_PLAN_TYPES } from 'constants/businessPlan';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { IBusinessPlansLimits } from 'interfaces/businessPlan';

import { IUserLimitsStore } from './types';

const defaultUserLimits: IBusinessPlansLimits = {
  availableDocumentCount: {
    [BUSINESS_PLAN_TYPES.ONE_PAGE]: 1,
    [BUSINESS_PLAN_TYPES.FOR_INVESTORS]: 1,
    [BUSINESS_PLAN_TYPES.FOR_BANK]: 1,
  },
  currentDocumentCount: {
    [BUSINESS_PLAN_TYPES.ONE_PAGE]: 0,
    [BUSINESS_PLAN_TYPES.FOR_INVESTORS]: 0,
    [BUSINESS_PLAN_TYPES.FOR_BANK]: 0,
  },
  maxDocumentLimit: {
    [BUSINESS_PLAN_TYPES.ONE_PAGE]: 1,
    [BUSINESS_PLAN_TYPES.FOR_INVESTORS]: 0,
    [BUSINESS_PLAN_TYPES.FOR_BANK]: 0,
  },
};

export const useUserLimits = create<IUserLimitsStore>()(
  devtools((set) => ({
    limits: defaultUserLimits,
    setLimits: (subscription) => set({ limits: subscription }),
    clearLimits: () => set({ limits: defaultUserLimits }),

    isLimitsLoading: false,
    setIsLimitsLoading: (isSubscriptionLoading) => set({ isLimitsLoading: isSubscriptionLoading }),
  })),
);
